// PRICE widget — maps to data-provider/source/instructions/PRICE

export type PriceChartRange = 'YTD' | '1M' | '3M' | '1Y' | '5Y' | '10Y';

/** How the chart plots: absolute prices, or % change rebased to the window start. */
export type PriceDisplayMode = 'price' | 'relative';

export const PRICE_DEFAULT_PROVIDER = 'AUTO';

// YTD has no fixed trading-day count — it slices from Jan 1 of the latest
// data year (see the renderer).
export const PRICE_RANGE_OPTIONS: Array<{ value: PriceChartRange; label: string; tradingDays?: number }> = [
  { value: 'YTD', label: 'YTD' },
  { value: '1M', label: '1M', tradingDays: 21 },
  { value: '3M', label: '3M', tradingDays: 63 },
  { value: '1Y', label: '1Y', tradingDays: 252 },
  { value: '5Y', label: '5Y', tradingDays: 1260 },
  { value: '10Y', label: '10Y', tradingDays: 2520 },
];

export interface PriceWidgetConfig {
  /** Legacy lookback override. Kept for backward compatibility with older configs. */
  horizon?: number;
  /** Preferred provider to use for this widget. AUTO lets the provider broker choose. */
  provider?: string;
  /** Optional design-time / preview ticker. Task execution still prefers the workflow asset. */
  ticker?: string;
  /** Comparison index ticker (e.g. "SPY") */
  index?: string;
  /** Default chart range shown when the widget loads */
  defaultRange?: PriceChartRange;
  /** Default display mode. Falls back to 'relative' when an index is configured. */
  displayMode?: PriceDisplayMode;
}

export interface PriceWidgetInstanceConfig extends PriceWidgetConfig {
  dataKey?: string;
}

// API response shape from POST /datasources/widgets → PRICE
export interface PriceHistoryRow {
  date: string;
  price: number;
  volume: number;
  adtv: number;
}

export interface PriceData {
  ticker: string;
  latest_price: number | null;
  latest_volume: number | null;
  adtv_3m: number | null;
  price_history: PriceHistoryRow[] | null;
  index_ticker: string | null;
  index_price_history: Array<{ date: string; price: number }> | null;
}
